export const HeatMapAnalyticsActivitySchemaName = 'HeatMapAnalyticsActivity';

export enum IHeatMapsAnalyticsActivityEnum {
  HeatmapSegment = `${HeatMapAnalyticsActivitySchemaName}.heatmapsegment`,
  LocalStartTime = `${HeatMapAnalyticsActivitySchemaName}.localstarttime`,
  LocalStartDate = `${HeatMapAnalyticsActivitySchemaName}.localstartdate`,
  StartTime = `${HeatMapAnalyticsActivitySchemaName}.starttime`,
  TotalDuration = `${HeatMapAnalyticsActivitySchemaName}.totalDuration`,
  Count = `${HeatMapAnalyticsActivitySchemaName}.count`,
  AppId = `${HeatMapAnalyticsActivitySchemaName}.appid`,
  UserId = `${HeatMapAnalyticsActivitySchemaName}.userid`,
  TeamId = `${HeatMapAnalyticsActivitySchemaName}.teamId`,
  DayCount = `${HeatMapAnalyticsActivitySchemaName}.dayCount`,
  SegmentActivityCount = `${HeatMapAnalyticsActivitySchemaName}.segmentactivitycount`,
  SegmentTotalDuration = `${HeatMapAnalyticsActivitySchemaName}.segmenttotalduration`,
  WeekdaySegment = `${HeatMapAnalyticsActivitySchemaName}.weekdaysegment`,
  HeatmapIntervalTimestamp = `${HeatMapAnalyticsActivitySchemaName}.heatmapintervaltimestamp`,
  ActivityFeedId = `${HeatMapAnalyticsActivitySchemaName}.activityfeedid`,
  UniqueDayCount = `${HeatMapAnalyticsActivitySchemaName}.uniquedaycount`,
}
